import { css, etiColors } from '@eti/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const getMargin = (withDirection, isOverWing) => {
  if (isOverWing) {
    return withDirection ? '0' : '0.625rem';
  }
  return withDirection ? '1.875rem' : '0.625rem';
};
const styles = (isEmptyRow, isLeft, isRight, isOverWing) => css`
  background-color: ${isEmptyRow ? 'transparent' : etiColors.grayScale[8]};
  margin-left: ${getMargin(isLeft, isOverWing)};
  margin-right: ${getMargin(isRight, isOverWing)};
  width: 0.3125rem;
`;
const Wall = _ref => {
  let {
    isEmptyRow,
    isLeft,
    isOverWing,
    isRight
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles(isEmptyRow, isLeft, isRight, isOverWing),
    "data-testid": isLeft ? 'leftWall' : 'rightWall'
  });
};
export default Wall;